var exports = {
  "eS": "ChatContentV2__RE6xDK",
  "cM": "ChatContentV2__contentWrapper__2BEyrP",
  "BL": "ChatContentV2__content__U623Sb",
  "hR": "ChatContentV2__header__98RUwU",
  "ue": "ChatContentV2__heading__Dkd2Ka",
  "tD": "ChatContentV2__heading-title__LnX52j",
  "lR": "ChatContentV2__heading-description__ZZsvsJ",
  "qp": "ChatContentV2__body__rqd65F",
  "Cf": "ChatContentV2__input__XSsLVS",
  "O9": "ChatContentV2__ideList__51C56u",
  "NA": "ChatContentV2__ideList-title__99MEY2",
  "TF": "ChatContentV2__footer__JNenwC",
};

module.exports = exports;
